import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { interpolateToJsx } from 'helpers/interpolate';
import { transformKeys } from 'helpers/object';
import { isObject } from 'helpers/verify';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';

// Takes a FormattedMessage style "Hello {name}" and munges it to
// "Hello $name" so it can work with the `interpolate` helper
const makeInterpolatable = message => (message || '').replace(/\{([a-zA-Z]+)\}/g, '$$$1');

const LINK_LOOKUP = {
  linkCookies: (
    <a target="_blank" rel="noopener noreferrer" href="/privacy#cookies">
      <FormattedMessage id="signup.consent.cookies" defaultMessage="Cookie Policy" />
    </a>
  ),
  linkPrivacy: (
    <a target="_blank" rel="noopener noreferrer" href="/privacy">
      <FormattedMessage id="signup.consent.privacy" defaultMessage="Privacy Policy" />
    </a>
  ),
  linkTerms: (
    <a target="_blank" rel="noopener noreferrer" href="/terms">
      <FormattedMessage id="signup.consent.terms" defaultMessage="Terms of Use" />
    </a>
  ),
};

export class ConsentMessage extends PureComponent {
  renderConsentString(message) {
    const INTERPOLATABLE_LOOKUP = transformKeys(key => `$${key}`, LINK_LOOKUP);
    return <span>{interpolateToJsx(makeInterpolatable(message), INTERPOLATABLE_LOOKUP)}</span>;
  }

  renderConsentObject(message) {
    return (
      <LocalizableMessage
        message={message}
        values={{
          linkCookies: LINK_LOOKUP.linkCookies,
          linkPrivacy: LINK_LOOKUP.linkPrivacy,
          linkTerms: LINK_LOOKUP.linkTerms,
        }}
      />
    );
  }

  render() {
    const { className, message } = this.props;
    return (
      <p className={className}>
        {isObject(message) ? this.renderConsentObject(message) : this.renderConsentString(message)}
      </p>
    );
  }
}

ConsentMessage.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string.isRequired,
};
